<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new product</small>
      </legend>
      <div>
        <form @submit.prevent="newProduct()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Product name</label>
                <input
                  type="text"
                  class="form-control product_name input_rounded"
                  placeholder="product name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Product measurement</label>
                <select name="product_measurement" class="form-control input_rounded product_measurement">
                  <option value>Select Measurement</option>
                  <option value="KG">KILOGRAMS</option>
                  <option value="PCS">PIECES</option>
                  <option value="LTS">LITRES</option>
                  <option value="SET">SET</option>
                  <option value="PAIR">PAIR</option>
                  <option value="MTR">METRES</option>
                </select>
              </div>
              <div class="form-group">
                <label>Selling price</label>
                <input
                  type="number"
                  class="form-control selling_price input_rounded"
                  placeholder="selling price"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Product description</label>
                <textarea
                  class="form-control product_description input_rounded"
                  placeholder="product description"
                  required
                ></textarea>
              </div>
              <div class="form-group">
                <label>Buying price</label>
                <input
                  type="number"
                  class="form-control buying_price input_rounded"
                  placeholder="buying price"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat btn-rounded creatingProduct">
            <i class="fa fa-plus"></i> create product
          </button>
          <button type="button" class="btn btn-info btn-flat btn-rounded creatingProductLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from "jquery";
export default {
  created() {},
  methods: {
    ...mapActions(["newProduct"])
  }
};
</script>
<style scoped>
.creatingProductLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/products/product.vue